import { ViewerActions } from './viewer.actions';

export const initialViewerState: IStateViewer = {
  fileName: '',
  hasMoreResults : false,
  continuationToken: '',
  content: [],
  active: 'Viewer',
  entries: undefined };

export function viewerReducer (state: IStateViewer = initialViewerState, action: any)  {
    switch (action.type) {
        case ViewerActions.UPDATE:
            return  {...state,  fileName: action.payload.fileName,
              hasMoreResults : action.payload.hasMoreResults,
              continuationToken: action.payload.continuationToken,
              content: action.payload.content};
        case ViewerActions.ACTIVATED:
            return {...state,  active: action.payload.tab};

        case ViewerActions.ADD:
            return {...state,  entries: action.payload.entries};
        default:
            return state;
    }
};
